import * as Yup from "yup";
import { z } from "zod";


export const signupFormValidationSchema = Yup.object().shape({

  firstName: Yup.string()
    .required("First name is required")
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name must be less than 50 characters"),

  lastName: Yup.string()
    .required("Last name is required")
    .min(2, "Last name must be at least 2 characters")
    .max(50, "Last name must be less than 50 characters"),

  username: Yup.string()
    .required("Username is required")
    .min(3, "Username must be at least 3 characters")
    .max(20, "Username must be less than 20 characters")
    .matches(/^[a-zA-Z0-9_]+$/, "Username can only contain letters, numbers, and underscores"),

  email: Yup.string()
    .required("Email is required")
    .transform((value) => (value ? value.trim().toLowerCase() : value))
    .matches(/^\S+$/, "Email must not contain spaces")
    .email("Invalid email address"),

  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[0-9]/, "password must contain at least one number")
    .matches(/[a-z]/, "password must contain at least one lower case letter"),

  referralCode: Yup.string().optional().max(20, "Referral code must be less than 20 characters"),

  subscribeToNewsletter: Yup.boolean().default(false),
});

export const SignupResponseSchema = z.object({
  message: z.string(),
  isTrackedInMeta: z.boolean().default(false),
  mixpanelPayload: z.record(z.unknown()).optional(),
  session_token: z.string().optional().nullable(),
  verification_flow_id: z.string().optional().nullable(), 
});

export type SignupResponse = z.infer<typeof SignupResponseSchema>;
